export default "__VITE_ASSET__CPMHpBsV__"